import { take, tap } from 'rxjs';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ViewContainerRef,
  Inject,
  LOCALE_ID
} from '@angular/core';
import { UsersService } from '@shared/services/users/users.service';
import { UserInfo } from '@shared/services/users/types/user-info';
import { Observable, filter } from 'rxjs';
import { IconsLoader } from '@shared/services/icons/icons-loader.service';
import { LanguagesService, Language } from '@shared/services/languages/languages.service';
import { ICompanyBase } from '@collections/companies/interfaces';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';


import { RequestInfoByCompanyIdGQL } from 'app/shared/services/request-info/request-info-by-company-id.gql.service';
import { CommonModule } from '@angular/common';
import { GetUserUrlPipe } from "../../../shared/pipes/get-user-url.pipe";
import { GetCompanyUrlPipe } from "../../../shared/pipes/get-company-url.pipe";
import { AvatarComponent } from "../../../shared/components/avatar/avatar.component";

@Component({
    selector: 'toolbar-menu',
    standalone: true,
    providers: [
        RequestInfoByCompanyIdGQL
    ],
    templateUrl: './toolbar-menu.component.html',
    styleUrls: ['./toolbar-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        RouterModule,
        CommonModule,
        GetUserUrlPipe,
        GetCompanyUrlPipe,
        AvatarComponent
    ]
})
export class ToolbarMenuComponent implements OnInit {
  user$: Observable<UserInfo>;

  languages: Language[];
  selectedLanguage: Language;
  
  get primaryCompany(): ICompanyBase {
    return this._primaryCompany;
  }
  _primaryCompany: ICompanyBase;

  constructor(
    private usersService: UsersService,
    private iconsLoader: IconsLoader,
    private languagesService: LanguagesService,
    private vc: ViewContainerRef,
    private requestInfoByCompanyIdGQL: RequestInfoByCompanyIdGQL,
    @Inject(LOCALE_ID) private locale: string
  ) {
    this.languages = this.languagesService.getLanguages();
    // Set the selected language from default languages
    this.selectedLanguage = languagesService.getCurrentLang();
    this.user$ = this.usersService.onUserChange
    .pipe(
      filter(u => !!u && !!u.profile),
      tap(u => {
        this._primaryCompany = u.profile.userCompanies?.find(us => us.primary)?.company;
      })
    );
  }

  ngOnInit(): void {
    this.iconsLoader.load('user');
    this.iconsLoader.load('halls');
    this.iconsLoader.load('stand');
    this.iconsLoader.load('newsletter');
  }

  logout(): void {
    this.usersService.logout();
  }

  addNewCompany() {
    this.usersService.openCompanyWizard();
  }

  isCustomer(){
    if(this.primaryCompany.accountType === "customer"){
      return true
    }
    else{
      return false
    }
  }
}
